import React from 'react';
import { Select, MenuItem, FormControl, Box, InputLabel } from '@mui/material';
import { TeamDropdown } from '../../../components/forms/Dropdowns/TeamDropdown';
import { EventDropdown } from '../../../components/forms/Dropdowns/EventDropdown';
import CategoryDropdown from '../../../components/forms/Dropdowns/CategoryDropdown';
import DivisionDropdown from '../../../components/forms/Dropdowns/DivisionDropdown';
import { REPORT_TYPES } from '../types';

export default function ReportSelector(props) {
  const {
    reportType,
    setReportType,
    eventsMap,
    selectedEvent,
    setSelectedEvent,
    teams,
    selectedTeam,
    setSelectedTeam,
    categoriesMap,
    selectedCategory,
    setSelectedCategory,
    divisionsMap,
    selectedDivision,
    setSelectedDivision
  } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <FormControl variant="standard" sx={{ minWidth: 260 }}>
        <InputLabel id="report-select-label">Report</InputLabel>
        <Select labelId="report-select-label" value={reportType} onChange={(e) => setReportType(e.target.value)} size="small">
          {REPORT_TYPES.map(r => (
            <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {reportType === 'byEvent' && (
          <EventDropdown
            eventsMapValues={eventsMap}
            value={selectedEvent}
            onChange={(e, selected) => {
              const uid = selected?.uid || e?.target?.value || '';
              setSelectedEvent(uid);
            }}
          />
        )}

        {reportType === 'byTeam' && (
          <TeamDropdown
            teamsMapValues={teams}
            value={selectedTeam}
            onChange={(e, selected) => {
              const uid = e?.target?.value || (selected && selected.uid) || '';
              setSelectedTeam(uid);
            }}
          />
        )}

        {reportType === 'byCategory' && (
          <CategoryDropdown
            categoriesMapValues={categoriesMap}
            value={selectedCategory}
            onChange={(e, selected) => {
              e.preventDefault();
              setSelectedCategory(selected);
            }}
          />
        )}

        {reportType === 'byDivision' && (
          <DivisionDropdown
            divisionsMapValues={divisionsMap}
            value={selectedDivision}
            onChange={(e, selected) => {
              e.preventDefault();
              setSelectedDivision(selected);
            }}
          />
        )}
      </Box>
    </Box>
  );
}
